import { addSideEffects, initAction } from '@poa/state';
import moment from 'moment';
import { clone } from '../shared/clone';
import { fetch, setDates } from './calendar.actions';

addSideEffects(fetch, async (payload, { actions, env, store }) => {
  try {
    const { startDate, endDate, teamLead } = store.calendar.filters;
    const response = await env.api.calendar2.fetchCalendar(payload.fetchType, startDate.unix(), endDate.unix(), teamLead);
    actions.calendarActions2.fetchSuccess(response);
  } catch (e) {
    console.error(e);
    actions.calendarActions2.fetchFailed();
    throw e;
  }
});

addSideEffects(setDates, async ({ startDate, endDate, shouldFetch = false }, { actions, env }) => {
  try {
    await env.storage.setItem('calendar-dates', clone({ startDate, endDate }));
  } catch (e) {
    console.error(e);
    throw e;
  }
});

// Restore presets on load
addSideEffects(initAction, async (_, { actions, env, store }) => {
  const dates = await env.storage.getItem('calendar-dates');

  if (dates) {
    actions.calendarActions2.setDates(
      dates.startDate ? moment(dates.startDate) : moment().add(-1, 'month')
        .hours(1),
      dates.endDate ? moment(dates.endDate) : moment(),
      false
    );
    return;
  }
});
